// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "95d06213167b81a64ef9b6a87ff58fd9146894e7/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};